import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBinLine } from "react-icons/ri";
import {
    FaGasPump,
    FaIndustry,
    FaRoad,
    FaChevronDown,
    FaShieldAlt,
} from "react-icons/fa";
import { MdDirectionsCar, MdSpeed } from "react-icons/md";
import Pelak from "../../../conponents/pelak-car";
import BottomSheet from "../../../conponents/bottom-sheet/bottom-sheet";
import DeleteCar from "../../../conponents/car/delete/delete-car";
import styles from "./CarListCard.module.css";

const CarListCard = ({ car }) => {
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const imageSrc = car?.imageUrl || "/default-avatar.png";

    const kilometer =
        car?.kilometer ?? "-";
    const fuelConsumption =
        car?.useFuel ?? "-";
    const weeklyDistance =
        car?.distancePerWeek ?? "-";
    const chassisNumber =
        car?.shasiNo || "-";
    const manufacturer =
        car?.company || "-";

    const handleToggle = () => setIsOpen((p) => !p);

    return (
        <>
            <article className={styles.card} dir="rtl">
                {/* ===== Header : Image | Title | Plate ===== */}
                <button
                    type="button"
                    className={styles.header}
                    onClick={handleToggle}
                    aria-expanded={isOpen}
                >
                    {/* تصویر ماشین - سمت چپ در RTL یعنی آخر */}
                    <div className={styles.imageWrapper}>
                        <img
                            src={imageSrc}
                            alt={car?.title || "خودرو"}
                            className={styles.carImage}
                        />
                    </div>

                    {/* نام و مدل - وسط */}
                    <div className={styles.titleWrapper}>
                        <h2 className={styles.title}>
                            {car?.title || "-"}
                        </h2>
                        <div className={styles.year}>
                            مدل {car?.productYear || "-"}
                        </div>
                    </div>

                    {/* پلاک - سمت راست در RTL یعنی اول */}
                    <div className={styles.plateWrapper}>
                        <Pelak
                            part1Pelak={car?.pelak1}
                            part2Pelak={car?.pelak2}
                            part3Pelak={car?.pelak3}
                            part4Pelak={car?.pelak4}
                        />
                    </div>

                    <FaChevronDown
                        className={`${styles.chevron} ${
                            isOpen ? styles.chevronOpen : ""
                        }`}
                    />
                </button>

                {/* ===== Collapsible body ===== */}
                <div
                    className={styles.collapseWrapper}
                    data-open={isOpen}
                >
                    <div className={styles.collapseInner}>
                        {/* ===== Stats Row (5 columns) ===== */}
                        <section className={styles.statsRow}>
                            <div className={styles.statItem}>
                                <FaShieldAlt
                                    className={`${styles.statIcon} ${styles.iconShield}`}
                                />
                                <span className={styles.statLabel}>
                                    شماره شاسی
                                </span>
                                <strong className={styles.statValue}>
                                    {chassisNumber}
                                </strong>
                            </div>

                            <div className={styles.statDivider} />

                            <div className={styles.statItem}>
                                <FaIndustry
                                    className={`${styles.statIcon} ${styles.iconIndustry}`}
                                />
                                <span className={styles.statLabel}>
                                    شرکت سازنده
                                </span>
                                <strong className={styles.statValue}>
                                    {manufacturer}
                                </strong>
                            </div>

                            <div className={styles.statDivider} />

                            <div className={styles.statItem}>
                                <FaRoad
                                    className={`${styles.statIcon} ${styles.iconRoad}`}
                                />
                                <span className={styles.statLabel}>
                                    مسافت در هفته
                                </span>
                                <strong className={styles.statValue}>
                                    {weeklyDistance}
                                    <small> کیلومتر</small>
                                </strong>
                            </div>

                            <div className={styles.statDivider} />

                            <div className={styles.statItem}>
                                <FaGasPump
                                    className={`${styles.statIcon} ${styles.iconFuel}`}
                                />
                                <span className={styles.statLabel}>
                                    مصرف سوخت
                                </span>
                                <strong className={styles.statValue}>
                                    {fuelConsumption}
                                    <small> لیتر در ۱۰۰ کیلومتر</small>
                                </strong>
                            </div>

                            <div className={styles.statDivider} />

                            <div className={styles.statItem}>
                                <MdSpeed
                                    className={`${styles.statIcon} ${styles.iconKm}`}
                                />
                                <span className={styles.statLabel}>
                                    کیلومتر فعلی
                                </span>
                                <strong className={styles.statValue}>
                                    {kilometer}
                                    <small> کیلومتر</small>
                                </strong>
                            </div>
                        </section>

                        {/* ===== Actions ===== */}
                        <div className={styles.actions}>
                            <Link
                                className={styles.editButton}
                                to={`/edit-car/${car?.id}`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <CiEdit size={20} />
                                <span>ویرایش خودرو</span>
                            </Link>

                            <button
                                type="button"
                                className={styles.deleteButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpenDelete(true);
                                }}
                            >
                                <RiDeleteBinLine size={19} />
                                <span>حذف خودرو</span>
                            </button>
                        </div>
                    </div>
                </div>
            </article>

            <BottomSheet
                isOpen={isOpenDelete}
                onClose={() => setIsOpenDelete(false)}
                snapPoint="250"
            >
                <DeleteCar
                    car={car}
                    closeButtomSheetHandler={() =>
                        setIsOpenDelete(false)
                    }
                />
            </BottomSheet>
        </>
    );
};

export default CarListCard;